export default "__VITE_ASSET__DppIvlEu__"